var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7501 0C8.0587 0 7.5001 0.558594 7.5001 1.25V1.94922C4.66807 2.39844 2.5001 4.85156 2.5001 7.8125V9.11719C2.5001 10.8906 1.89463 12.6133 0.789166 13.9961L0.207134 14.7266C-0.0194282 15.0078 -0.0623969 15.3945 0.0938531 15.7188C0.250103 16.043 0.578228 16.25 0.937603 16.25H16.5626C16.922 16.25 17.2501 16.043 17.4064 15.7188C17.5626 15.3945 17.5196 15.0078 17.2931 14.7266L16.711 14C15.6056 12.6133 15.0001 10.8906 15.0001 9.11719V7.8125C15.0001 4.85156 12.8321 2.39844 10.0001 1.94922V1.25C10.0001 0.558594 9.44151 0 8.7501 0ZM8.7501 3.75H9.0626C11.3048 3.75 13.1251 5.57031 13.1251 7.8125V9.11719C13.1251 10.9883 13.6681 12.8125 14.6759 14.375H2.82432C3.83213 12.8125 4.3751 10.9883 4.3751 9.11719V7.8125C4.3751 5.57031 6.19542 3.75 8.4376 3.75H8.7501ZM11.2501 17.5H8.7501H6.2501C6.2501 18.1641 6.51182 18.8008 6.98057 19.2695C7.44932 19.7383 8.08604 20 8.7501 20C9.41417 20 10.0509 19.7383 10.5196 19.2695C10.9884 18.8008 11.2501 18.1641 11.2501 17.5Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.d5be6a64d52d89397f99c66913c20ab9.svg";
export { ForwardRef as ReactComponent };